import { Box } from '@hover/blueprint';
import type { BaseMessage, JwtMessage } from '@hover/embed/post-message-api';
import React from 'react';
import { useHistory, useLocation } from 'react-router';

import { TextOverlay } from 'src/modules/homeownerApp/components/Customize/TextOverlay';
import { isMessageOfType } from 'src/modules/homeownerApp/components/Embed/types';
import { LoadingTextEllipsis } from 'src/modules/homeownerApp/components/LoadingText';
import {
  TranslationNamespace,
  useEffectOnMount,
  useTranslate,
} from 'src/shared/hooks';
import { useAuthenticateWithToken } from 'src/shared/hooks/useAuthenticateWithToken/useAuthenticateWithToken';
import { Route } from 'src/shared/route';
import { logError } from 'src/shared/telemetry/logger';

export const LoginWithToken = () => {
  const t = useTranslate(TranslationNamespace.SHARED);
  const authenticateWithToken = useAuthenticateWithToken();
  const history = useHistory();
  const { search } = useLocation();

  const authenticateAndPushToDesigner = async (token: string) => {
    try {
      await authenticateWithToken(token);
    } catch (e) {
      logError(e as Error);
    }

    history.push(Route.HOMEOWNER_APP_HOME.path + search);
  };

  const handleJwtMessage = (event: MessageEvent<BaseMessage>) => {
    if (event.origin !== window.location.origin) {
      return;
    }

    if (isMessageOfType<JwtMessage>(event, 'jwt')) {
      const { jwt } = event.data?.payload;

      if (jwt) {
        void authenticateAndPushToDesigner(jwt);
        window.removeEventListener('message', handleJwtMessage);
      }
    }
  };

  useEffectOnMount(() => {
    window.addEventListener('message', handleJwtMessage);

    return () => {
      window.removeEventListener('message', handleJwtMessage);
    };
  });

  return (
    <Box h="1" w="1">
      <TextOverlay
        alignItems="start"
        h="1"
        headerColor="text.primary"
        justifyContent="center"
        pt={1200}
        w="1"
      >
        <span>{t('loggingYouIn')}</span>
        <LoadingTextEllipsis />
      </TextOverlay>
    </Box>
  );
};
